
import React from "react";

interface CountyCTASectionProps {
  countyName: string;
}

export function CountyCTASection({ countyName }: CountyCTASectionProps) {
  return (
    <div className="bg-grandpal-beige/50 py-12 mt-8">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-semibold mb-4">
            Need help choosing a nursing home in {countyName}?
          </h2>
          <p className="text-lg mb-6 text-grandpal-gray">
            Our advisors can guide you through available options and help you make the best choice for your loved ones.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button 
              className="bg-grandpal-green hover:bg-grandpal-green-light text-white px-6 py-3 rounded-md font-medium transition-colors"
              onClick={() => window.location.href = "/contact?county=" + countyName.toLowerCase()}
            >
              Speak to an Advisor
            </button>
            <button 
              className="border border-grandpal-green text-grandpal-green hover:bg-grandpal-green/10 px-6 py-3 rounded-md font-medium transition-colors"
              onClick={() => window.open('/guides/fair-deal', '_blank')}
            >
              Download Fair Deal Guide
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

